<template>
  <div class="form">
    <div class="form__information">
      <h2 class="form__title">REDEFINIÇÃO DE SENHA</h2>
      <p class="form__description">Escolha qual método deseja para rededefinir sua senha.</p>
    </div>
    <ul class="list">
      <li class="item">
        <router-link :to="{ name: 'home', params: { resetPass: 'reset-password', resetBy: 'email'} }" class="link">
          <svg class="svg" width="60" height="33" viewBox="0 0 60 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect class="icon" x="8.78711" y="0.5" width="42" height="32" rx="3.83803" stroke="var(--primary-color)"/>
            <path class="icon"
                  d="M26.6872 18.3839L10.4867 6.85133C7.71044 4.87504 9.10861 0.500001 12.5164 0.500001L47.1371 0.500001C50.573 0.500001 51.9519 4.93426 49.1219 6.88277L32.3535 18.4283C30.6431 19.6059 28.3789 19.5882 26.6872 18.3839Z"
                  stroke="var(--primary-color)"/>
          </svg>
          <span class="link__title"> RECEBER E-MAIL DE RECUPERAÇÃO </span>
        </router-link>
      </li>
      <li class="item">
        <router-link :to="{ name: 'home', params: { resetPass: 'reset-password', resetBy: 'identity'} }" class="link">
          <svg class="svg" width="60" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle class="icon" cx="15" cy="8" r="7.5" stroke="var(--primary-color)"/>
            <path class="icon" d="M1 30V30C6.67692 18.8544 22.4715 18.4977 28.6457 29.3758L29 30" stroke="var(--primary-color)"/>
          </svg>
          <span class="link__title"> REDEFINIR COM O CONNECT RH </span>
        </router-link>
      </li>
      ou
      <li class="item">
        <a href="mailto:decola@lince.com.br" class="link last">
          <svg class="svg" width="60" height="33" viewBox="0 0 60 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect class="icon" x="8.78711" y="0.5" width="42" height="32" rx="3.83803" stroke="var(--primary-color)"/>
            <path class="icon"
                  d="M26.6872 18.3839L10.4867 6.85133C7.71044 4.87504 9.10861 0.500001 12.5164 0.500001L47.1371 0.500001C50.573 0.500001 51.9519 4.93426 49.1219 6.88277L32.3535 18.4283C30.6431 19.6059 28.3789 19.5882 26.6872 18.3839Z"
                  stroke="var(--primary-color)"/>
          </svg>
          <span class="link__title"> ENTRE EM CONTATO </span>
          <svg class="svg" width="60" height="8" viewBox="0 0 30 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="icon" d="M29.3536 4.35355C29.5488 4.15829 29.5488 3.84171 29.3536 3.64645L26.1716 0.464466C25.9763 0.269204 25.6597 0.269204 25.4645 0.464466C25.2692 0.659728 25.2692 0.976311 25.4645 1.17157L28.2929 4L25.4645 6.82843C25.2692 7.02369 25.2692 7.34027 25.4645 7.53553C25.6597 7.7308 25.9763 7.7308 26.1716 7.53553L29.3536 4.35355ZM0 4.5L29 4.5V3.5L0 3.5L0 4.5Z" fill="var(--primary-color)"/></svg>
        </a>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: "ResetOptions",
}
</script>

<style scoped>
.form, .form__information, .list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.form {
  height: 100%;
  max-height: 400px;
  min-height: 400px;
  justify-content: space-between;
  align-items: center;
  color: #959595;
}

.form__information {
  gap: 2rem;
}

.form__title {
  font-size: 1.125rem;
  color: var(--primary-color);
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 1.2rem;
}

.form__description {
  font-size: 1rem;
  color: #959595;
  line-height: 1.2rem;
  font-weight: 400;
}

.list {
  gap: 1rem;
  width: 100%;
  align-items: center;
}

.item {
  height: 68px;
  width: inherit;

  border: 1px solid var(--primary-color);
  border-radius: 4px;
}

.item:hover, .link:focus {
  background: linear-gradient(144.94deg, var(--primary-color) 6.02%, var(--secondary-color)150.91%);
  border: 1px solid transparent;
  outline: none;
}

.link:focus .link__title {
  color: #fff;
}

.link:focus .icon {
  stroke: #fff;
}

.link {
  display: flex;
  align-items: center;
  height: inherit;
  padding: 0 0.5rem;
  gap: 0.5rem;
  white-space: nowrap;
}

.last {
  justify-content: space-between;
}


.link__title {
  font-size: 0.8rem;
  color: var(--primary-color);
}

.item:hover .link__title {
  color: #fff;
}

.item:hover .icon {
  stroke: #fff;
}

@media screen and (max-width: 420px){

  .link {
    justify-content: center;
    text-decoration: none;
  }

  .link__title {
    font-size: 0.8rem;
  }

  .item {
    width: 100%;
    height: 50px;
  }

  .svg {
    display: none;
  }
}
</style>